import Marquee from './marquee';
import LinkCursor from '../../components/molecules/link-cursor';

export default class CtaMarquee {
    constructor(element) {
        if (!element) return;

        this.element = element;

        return this.init();
    }

    init() {
        const marquee = new Marquee(this.element, {
            markers: false,
        });
        const linkCursor = new LinkCursor(this.element, true);

        return {
            marquee: marquee,
            linkCursor: linkCursor,
        };
    }
}
